export default __webpack_public_path__ + "static/media/i_bus-jeonse_yl_tagless.5115ee7d.svg";